export default class AuthService {
  static async getService(bankName: string): Promise<any> {
    let AuthorizeService;
    if (bankName.toLowerCase() === "kotak") {
      const module = await import(
        "../Controller/Kotak/Services/AuthorizeService"
      );
      AuthorizeService = module.default;
    } else {
      throw new Error(`Unsupported bank: ${bankName}`);
    }
    return new AuthorizeService();
  }
}
